<div class="card icon-detail-card">
  <div class="card-block">
    <div class="card-title" cds-text="medium" cds-layout="horizontal m-b:lg m-t:md gap:sm">
      <div>{{ iconName }}</div>
      <div
        *ngIf="iconName | appIconAliases; let iconAliases"
        class="icon-detail-card__aliases"
        cds-text="caption"
        cds-layout="m-t:xs"
      >
        aliases: {{ iconAliases | json }}
      </div>
    </div>
    <div class="card-text">
      <app-code-snippet [code]="iconName | appIconCode: selectedIconVariant"></app-code-snippet>
      <div cds-layout="m-t:lg">
        <button
          *ngFor="let iconVariant of iconDetails | appIconVariants"
          [attr.aria-label]="iconName | appIconAriaLabel: iconVariant"
          class="icon-detail-card__variant"
          [ngClass]="{
            'icon-detail-card__variant--selected':
              selectedIconVariant?.solid === iconVariant.solid && selectedIconVariant?.badge === iconVariant.badge
          }"
          (click)="selectedIconVariant = iconVariant"
        >
          <cds-icon
            size="md"
            status="neutral"
            [shape]="iconName"
            [solid]="iconVariant.solid"
            [badge]="iconVariant.badge"
          ></cds-icon>
        </button>
      </div>
    </div>
  </div>
  <div cds-layout="horizontal" class="card-footer">
    See more usage options in <a routerLink="/documentation/icons/api/">How To Use</a>
    <button class="btn btn-outline btn-sm" cds-layout="align:right" (click)="downloadSelectedIcon()">
      <cds-icon shape="download" class="download-svg-icon"></cds-icon> SVG Icon
    </button>
  </div>
</div>
